import PropTypes from 'prop-types';
import spinner from './localiq-loading.svg';
import { SpinnerImg } from './styled';

export default function LocalIQSpinner({ height, width }) {
  return (
    <SpinnerImg
      $height={height}
      $width={width}
      src={spinner}
      alt="Loading Spinner"
    />
  );
}

LocalIQSpinner.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};
